module.exports = __webpack_public_path__ + "img/camel-comb1-2.fa84e720.jpg";